import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import { getCurrentCulture } from "@utils";
import { OfferStoreContext } from "@gp/components";
import { LiveSideNavigationInteractionTypeEnum } from "@data-types/analytics-tracker/LiveSideNavigationTypeEnum";
import { analyticsTracker } from "@utils/analytics";
import { SideMenuLink, SideMenuLinkItem } from ".";

export const SecondaryLiveMenuLinkItems = observer(
	function SecondaryLiveMenuLinkItems() {
		const culture = getCurrentCulture();
		const menuStore = useContext(OfferStoreContext);
		const { pathname } = useLocation();

		const trackSideNavigationClick =
			(url: string, type: LiveSideNavigationInteractionTypeEnum) =>
			() => {
				if (url !== pathname) {
					analyticsTracker.trackLiveSideNavigationInteraction(type);
				}
			};

		const upcomingUrl = `/${culture}/live/upcoming`;
		const highlightsUrl = `/${culture}/live/highlights`;
		const liveStreamUrl = `/${culture}/live/live-stream`;

		const menuLinkItems: SideMenuLinkItem[] = [
			{
				translationKey: "LIVE.SIDEMENU.UPCOMING",
				url: upcomingUrl,
				iconClassExtension: "upcoming",
				countKey: "upcomingEventsCount",
				callOnUserAction: trackSideNavigationClick(
					upcomingUrl,
					LiveSideNavigationInteractionTypeEnum.Upcoming
				),
			},
			{
				translationKey: "LIVE.SIDEMENU.HIGHLIGHTS",
				url: highlightsUrl,
				iconClassExtension: "live-highlights",
				countKey: "totalHighlightsCount",
				callOnUserAction: trackSideNavigationClick(
					highlightsUrl,
					LiveSideNavigationInteractionTypeEnum.Highlights
				),
			},
		];

		// @ts-expect-error
		if (menuStore.liveStreamEventCount > 0) {
			menuLinkItems.push({
				translationKey: "SIDE_MENU.EVENTS_WITH_LIVE_STREAM",
				url: liveStreamUrl,
				iconClassExtension: "live-stream",
				countKey: "liveStreamEventCount",
				callOnUserAction: trackSideNavigationClick(
					liveStreamUrl,
					LiveSideNavigationInteractionTypeEnum.LiveStream
				),
			});
		}

		return (
			<>
				{menuLinkItems.map((item) => (
					<SideMenuLink key={item.url} item={item} />
				))}
			</>
		);
	}
);
